var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppSection',{attrs:{"id":"timesheets","type":"page","title":_vm.$t(_vm.$getConst.pages.timesheet.add_timesheet)}},[_c('TimesheetForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }